import React, { Component } from 'react';

import Voltar from '../../components/Links/Voltar';
import Titulo from '../../components/Texto/Titulo';

import { connect } from 'react-redux';
import * as actions from '../../actions/entregas';
import { updateEntrega } from '../../actions/pedidos';

import ButtonToolbar from '../../components/Button/Toolbar';

import CardComponent from '../../components/Card/cardDelivery';
import { PEDIDO_ENTREGUE } from '../../constants/entregaStatus';

function formatarData(iso){
	if(!iso) return '—';
	try {
		return new Date(iso).toLocaleString('pt-BR');
	}catch(e){
		return String(iso);
	}
}

class Entrega extends Component {

	state = { aviso: null }

	componentDidMount(){
		const { usuario } = this.props;
		const { id } = this.props.match.params;
		if(!usuario) return null;
		this.props.getEntrega(id, usuario.loja);
	}

	componentWillUnmount(){
		this.props.limparEntrega();
	}

	cancelarEntrega = () => {
		const { usuario, entrega } = this.props;
		if(!usuario || !entrega) return null;
		if(window.confirm("Você realmente deseja cancelar esta entrega?")){
			this.props.updateEntrega({ status: "Cancelado pela loja", responsavel: usuario.nome }, entrega._id, usuario.loja, (error) => {
				this.setState({
					aviso: { 
						status: !error,
						msg: error ? error.message : "Entrega cancelada com sucesso!" 
					} 
				});
			});
		}
	}

	confirmarEntrega = () => {
		const { usuario, entrega } = this.props;
		if(!usuario || !entrega) return null;
		if(window.confirm("Deseja mesmo confirmar esta entrega? Lembre-se que uma notificação será enviada ao comprador!")){
			this.props.updateEntrega({ status: PEDIDO_ENTREGUE, responsavel: usuario.nome }, entrega._id, usuario.loja, (error) => {
				this.setState({
					aviso: { 
						status: !error,
						msg: error ? error.message : "Entrega confirmada com sucesso!" 
					} 
				});
			});
		}
	}

	render(){
		if(!this.props.entrega) return null;
		const { entrega } = this.props;

		const tentativas = Array.isArray(entrega.tentativas) ? entrega.tentativas : [];
		const entregadorAtual = entrega.entregador && entrega.entregador.nome ? entrega.entregador.nome : null;
		const loteCodigo = entrega.loteAtual && entrega.loteAtual.codigo ? entrega.loteAtual.codigo : null;

		const podeAcoesManuais = entrega.status !== PEDIDO_ENTREGUE && entrega.status !== "Cancelado pela loja";

		return (
			<div className="content-box entregadetail">
				<div className="content-tools">
					<Voltar history={this.props.history} />
					{ podeAcoesManuais && (
						<div className="tools">
							<ButtonToolbar type="danger" label="Cancelar Entrega" icon="fas fa-times" onClick={() => this.cancelarEntrega()} />
							<ButtonToolbar type="success" label="Confirmar Entrega" icon="fas fa-check" onClick={() => this.confirmarEntrega()} />
						</div>
					)}
				</div>
				<div className="card">
					<Titulo tipo="h1" titulo={`Entrega #${entrega.simpleId ? entrega.simpleId : entrega._id}`}/>
					<div className="destaque-one">
						<div className="entregaDetails">
							{ entrega.status === PEDIDO_ENTREGUE ? (
									<div className="status-wrapper">
										<span className="status status-success">{entrega.status}</span>
										{entrega.lastResponsible && (<span className="status-complement">Atualizado por {entrega.lastResponsible}</span>)}
									</div>
								) : (
									<div className="status-wrapper">
										<span className="status status-default">{entrega.status}</span>
									</div>
							) }
							{ entregadorAtual && <h4>Entregador atual: {entregadorAtual}</h4> }
							{ loteCodigo && <h4>Lote atual: {loteCodigo}</h4> }
							<h4>Data de entrega: {entrega.shippingDate}</h4>
							<h4>Período: {entrega.shippingPeriod}</h4>
							<h4>Quem envia: {entrega.shippingSender}</h4>
							<h4>Quem recebe: {entrega.shippingRecipient}</h4>
						</div>

						{ tentativas.length > 0 && (
							<div className="entregaTentativas">
								<h2 className="Titulo-primario">Histórico de tentativas</h2>
								<p className="entregaTentativas-lead">Todas as tentativas são mantidas; novas reentregas adicionam um novo lote sem apagar o histórico anterior.</p>
								<ul className="entregaTentativas-lista">
									{ tentativas.map((t, idx) => {
										const nomeEnt = t.entregador && t.entregador.nome ? t.entregador.nome : '—';
										const codLote = t.lote && t.lote.codigo ? t.lote.codigo : '—';
										let resumoResultado = 'Em andamento';
										if(t.resultado === 'entregue') resumoResultado = 'Entregue';
										if(t.resultado === 'nao_entregue') resumoResultado = 'Não entregue';
										return (
											<li key={t._id || idx} className="entregaTentativas-item">
												<strong>Tentativa {idx + 1}</strong>
												<span>Lote {codLote} · {nomeEnt}</span>
												<span>Atribuído em {formatarData(t.atribuidoEm)}</span>
												{ t.saiuParaEntregaEm && <span>Saiu para entrega em {formatarData(t.saiuParaEntregaEm)}</span> }
												{ t.notificacaoWhatsApp && t.notificacaoWhatsApp.enviadoEm && (
													<span>WhatsApp enviado em {formatarData(t.notificacaoWhatsApp.enviadoEm)}</span>
												) }
												<span className="entregaTentativas-resultado">Resultado: {resumoResultado}</span>
												{ t.resultado === 'nao_entregue' && t.motivoNaoEntrega && (
													<span className="entregaTentativas-motivo">Motivo: {t.motivoNaoEntrega}</span>
												) }
												{ t.prova && t.prova.registradoEm && (
													<span className="entregaTentativas-prova">Prova registrada em {formatarData(t.prova.registradoEm)}</span>
												) }
											</li>
										);
									}) }
								</ul>
							</div>
						) }

						{ entrega.shippingMessageSelect ? (<CardComponent dataDelivery={entrega} />) : (<><h1 className="Titulo-primario">Cartão</h1><p>O cliente não adicionou cartão ao pedido.</p></>) }
						
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => ({
  entrega: state.entrega.entrega,
  registros: state.entrega.entregaRegistros,
	usuario: state.auth.usuario
});

export default connect(mapStateToProps, { ...actions, updateEntrega })(Entrega);
